import { ReactNode, useMemo } from "react"

import { FeatureFlagReadModel, FlagState } from "featureFlags/domain/flag"
import { FeatureFlagReadModelFactory } from "featureFlags/features/getFeatureFlag/factory"

interface BehindFeatureFlagProps {
  children: ReactNode
  flagName: string
  flagReadModel?: FeatureFlagReadModel
}

const BehindFeatureFlag = ({
  children,
  flagName,
  flagReadModel = new FeatureFlagReadModelFactory().build()
}: BehindFeatureFlagProps) => {
  const flag = useMemo(
    () => flagReadModel.getByName(flagName),
    [flagName, flagReadModel]
  )

  if (flag.getCurrentState() === FlagState.Enabled) {
    return children
  } else {
    return null
  }
}

export default BehindFeatureFlag
